import React from 'react';

const ModalVivenciado = (props) => {
   return(
      <div className="col-md-12">
         <div className="modal__header">
            <h1>Relate o que você viu</h1>
            <h4>(Profissionais da linha de frente e população em geral)</h4>
            <p>Atenção: Apesar de serem permitidas denúncias anônimas, não são aceitos relatos falsos.</p>
         </div>
      </div>
   )
}

export default ModalVivenciado;
